// Audio utility functions for cat sounds
export const playSound = (soundPath, fallbackMessage = '') => {
  try {
    const audio = new Audio(soundPath);
    
    // Set volume to reasonable level
    audio.volume = 0.5;
    
    // Handle loading errors
    audio.addEventListener('error', (e) => {
      console.log(`🐱 Cat sound not available: ${soundPath}`);
      if (fallbackMessage) {
        console.log(`🎵 ${fallbackMessage}`);
      }
    });
    
    // Play the sound
    const playPromise = audio.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.log(`🐱 Cat sound play failed: ${soundPath} - ${error.message}`);
        if (fallbackMessage) {
          console.log(`🎵 ${fallbackMessage}`);
        }
      });
    }
  } catch (error) {
    console.log(`🐱 Cat sound error: ${soundPath} - ${error.message}`);
    if (fallbackMessage) {
      console.log(`🎵 ${fallbackMessage}`);
    }
  }
};

// Predefined cat sounds with fallback messages
export const CAT_SOUNDS = {
  MEOW_EXCITED: '/cat-sounds/meow-excited.mp3',
  MEOW_HAPPY: '/cat-sounds/meow-happy.mp3', 
  MEOW_SURPRISE: '/cat-sounds/meow-surprise.mp3',
  PURR_CONTENT: '/cat-sounds/purr-content.mp3',
  PURR_LOUD: '/cat-sounds/purr-loud.mp3',
  PURR_ROLL: '/cat-sounds/purr-roll.mp3'
};

export const FALLBACK_MESSAGES = {
  [CAT_SOUNDS.MEOW_EXCITED]: 'EXCITED MEOW! 😸',
  [CAT_SOUNDS.MEOW_HAPPY]: 'Happy meow! 😺',
  [CAT_SOUNDS.MEOW_SURPRISE]: 'Surprise meow! 😯',
  [CAT_SOUNDS.PURR_CONTENT]: 'Content purring... 😌',
  [CAT_SOUNDS.PURR_LOUD]: 'LOUD PURRING! 😻',
  [CAT_SOUNDS.PURR_ROLL]: 'Rolling purr... 🎲'
};

// Convenience functions
export const playMeowExcited = () => playSound(CAT_SOUNDS.MEOW_EXCITED, FALLBACK_MESSAGES[CAT_SOUNDS.MEOW_EXCITED]);
export const playMeowHappy = () => playSound(CAT_SOUNDS.MEOW_HAPPY, FALLBACK_MESSAGES[CAT_SOUNDS.MEOW_HAPPY]);
export const playMeowSurprise = () => playSound(CAT_SOUNDS.MEOW_SURPRISE, FALLBACK_MESSAGES[CAT_SOUNDS.MEOW_SURPRISE]);
export const playPurrContent = () => playSound(CAT_SOUNDS.PURR_CONTENT, FALLBACK_MESSAGES[CAT_SOUNDS.PURR_CONTENT]);
export const playPurrLoud = () => playSound(CAT_SOUNDS.PURR_LOUD, FALLBACK_MESSAGES[CAT_SOUNDS.PURR_LOUD]);
export const playPurrRoll = () => playSound(CAT_SOUNDS.PURR_ROLL, FALLBACK_MESSAGES[CAT_SOUNDS.PURR_ROLL]);